<script lang="ts">
	import type { AdId } from '$lib/services/advertising/types';
	import { page } from '$app/state';
	import GoogleAd from '$lib/components/advertising/GoogleAd.svelte';
	import { getAdFormatFromDeviceWidth } from '$lib/components/advertising/utils';
	import { type AdFormats } from '$lib/services/advertising';
	import { getAdId, getItaliaAdUnit, getItaliaPageName } from '$lib/services/advertising/italia';
	import { getTargeting } from '$lib/services/advertising/tracking';
	import { getSearchParamsStore } from '$lib/services/urls/searchParams';
	import { onMount } from 'svelte';

	interface Props {
		adFormat: AdFormats;
		adId: AdId;
		showAdByDefault: boolean;
		adIdForTests: AdId;
		onAdAvailabilityChange?: (isAvailable: boolean) => void;
	}

	const {
		adFormat,
		adId,
		showAdByDefault,
		adIdForTests,
		onAdAvailabilityChange,
	}: Props = $props();

	const searchParams = getSearchParamsStore();
	const format = getAdFormatFromDeviceWidth(adFormat) || '1x1';
	const { itineraryResultsStore, waypointsInfo } = $derived(page.data);
	const adUnit = $derived(getItaliaAdUnit(format, page, $searchParams, adId));

	onMount(() => {
		const section = getItaliaPageName(page, $searchParams, adId);
		const targeting = getTargeting({
			searchParams: $searchParams,
			route:
				typeof $searchParams.selectedRoute === 'number'
					? $itineraryResultsStore?.routes[$searchParams.selectedRoute]
					: undefined,
			waypoints: $itineraryResultsStore?.waypoints,
			arrivalAddress: $itineraryResultsStore?.arrivalAddress,
			departureAddress: $itineraryResultsStore?.departureAddress,
			searchWaypoints: waypointsInfo,
			page,
			adId,
		});

		window.pubAdsCfg = window.pubAdsCfg || { section: {}, customCriteria: {} };
		window.pubAdsCfg.section = section;
		window.pubAdsCfg.customCriteria = targeting;

		window.IOL?.adv?.refreshSlot?.();
		onAdAvailabilityChange?.(true);
	});
</script>

<GoogleAd {adFormat} {adIdForTests} adId={getAdId(adId)} {adUnit} {showAdByDefault} {onAdAvailabilityChange} />
